import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const EIN_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.einService.buyBox.bulletPoint1' },
        { title: 'productPage.einService.buyBox.bulletPoint2' },
        { title: 'productPage.einService.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.einService.buyBox.productName',
      interactService: {
        ctaType: 'internalCheckout',
        service: 'ein_creation'
      }
    }],
    headerPicture: {
      src: '/s2/raster/store-plants-laptop.png',
      alt: 'productPage.einService.heroPicture.altText'
    },
    headline: 'productPage.einService.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.einService.page.headlinePill',
      bgcolor: 'background.orange.light'
    },
    subheader: 'productPage.einService.page.subheader'
  },
  benefit: {
    title: 'productPage.einService.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/savingsrounded.svg',
        title: 'productPage.einService.valueProp.propTitle1',
        description: 'productPage.einService.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.einService.valueProp.propTitle2',
        description: 'productPage.einService.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/assignmentindrounded.svg',
        title: 'productPage.einService.valueProp.propTitle3',
        description: 'productPage.einService.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.einService.valueProp.propTitle4',
        description: 'productPage.einService.valueProp.shortCopy4'
      },
      {
        icon: '/s2/material-icons/badgerounded.svg',
        title: 'productPage.einService.valueProp.propTitle5',
        description: 'productPage.einService.valueProp.shortCopy5'
      },
      {
        icon: '/s2/material-icons/paymentsrounded.svg',
        title: 'productPage.einService.valueProp.propTitle6',
        description: 'productPage.einService.valueProp.shortCopy6'
      }
    ]
  },
  howItWorks: {
    title: 'productPage.einService.howItWorks.title',
    items: [
      {
        title: 'productPage.einService.howItWorks.step1',
        description: 'productPage.einService.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.einService.howItWorks.step2',
        description: 'productPage.einService.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.einService.howItWorks.step3',
        description: 'productPage.einService.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/bikeshop-owner-tablet.png',
    alt: 'productPage.einService.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.einService.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.einService.frequentlyAskedQuestions.faq1',
        answer: 'productPage.einService.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.einService.frequentlyAskedQuestions.faq2',
        answer: 'productPage.einService.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.einService.frequentlyAskedQuestions.faq3',
        answer: 'productPage.einService.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.einService.frequentlyAskedQuestions.faq4',
        answer: 'productPage.einService.frequentlyAskedQuestions.faqAnswer4'
      },
      {
        question: 'productPage.einService.frequentlyAskedQuestions.faq5',
        answer: 'productPage.einService.frequentlyAskedQuestions.faqAnswer5'
      },
      {
        question: 'productPage.einService.frequentlyAskedQuestions.faq6',
        answer: 'productPage.einService.frequentlyAskedQuestions.faqAnswer6'
      }
    ]
  },
  assistance: {
    title: 'productPage.einService.needAssistance.title',
    getInTouch: 'productPage.einService.needAssistance.getInTouch',
    actions: 'productPage.einService.needAssistance.actions'
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.einService.buyBox.buttonLabel'
  })
};
